import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
export const navigationLinkContainerStyles = ({ $color, theme, }) => css `
	white-space: nowrap;
	margin: 0;
	display: inline-flex;
	align-items: center;
	gap: ${pxToRem(theme.spacing['50'])};

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: ${theme.borderWidth.m}px;
	}

	${$color === 'secondary' &&
    css `
		&,
		* {
			position: relative;
			color: ${theme.colors.base.textBody};

			&:hover {
				color: ${theme.colors.base.textBodyLinkHover};

				&::after {
					content: '';
					position: absolute;
					right: 0;
					bottom: 0;
					left: 0;
					height: ${theme.borderWidth['2']}px;
					background-color: currentcolor;
				}
			}

			&:active {
				color: ${theme.colors.action.textActive};
			}
		}
	`};
`;
export const NavigationLinkContainer = styled(Typography) `
	${navigationLinkContainerStyles}
`;
